import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TextField } from 'material-ui';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import styles from 'styles';

import CompaniesRealNamesRow from './CompaniesRealNamesRow';
import Pagination from 'components/Libs/Pagination';
import _ from 'lodash';

function CompaniesRealNamesTable({ companies }) {
    
    const rowsPerPage = [20, 50, 100];
    const [rows, setRows] = useState([]);
    const [rowsForPagination, setRowsForPagination] = useState([]);
    const [page, setPage] = useState(1);
    const [numberOfRows, setNumberOfRows] = useState(20);
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        handleUpdateRow({ page, numberOfRows }, searchText);
    }, [companies]);

    const changeRowsByPagination = (page, numberOfRows, searchText) => {
        const elementsOnPage = numberOfRows;
        const offset = page - 1;
        const from = offset * elementsOnPage;
        const to = (offset * elementsOnPage) + elementsOnPage;

        let companiesCopy = _.cloneDeep(companies);

        if (searchText) {
            const regex = new RegExp(`^${searchText}`, 'i');
            companiesCopy = companiesCopy.filter(i => regex.test(i.name));
        }

        setRowsForPagination(companiesCopy);

        return companiesCopy.slice(from, to);
    };

    const handleUpdateRow = ({ page, numberOfRows }, searchText) => {
        setRows(changeRowsByPagination(page, numberOfRows, searchText));
        setPage(page);
        setNumberOfRows(numberOfRows);
    };

    const handleSearch = (e) => {
        const searchText = e.target.value;
        if (searchText.length < 2) {
            setRows(changeRowsByPagination(1, numberOfRows, ''));
            setSearchText('');
            return;
        }
        setPage(1);
            
        handleUpdateRow({ page: 1, numberOfRows }, searchText);
        setSearchText(searchText);
    };

    const renderPagination = (
        <Pagination
            total={rowsForPagination.length}
            rowsPerPage={rowsPerPage}
            page={page}
            numberOfRows={numberOfRows}
            updateRows={e => handleUpdateRow(e, searchText)}
        />
    );

    return (
        <div>
            <div className='table-header' style={{ justifyContent: 'space-between' }}>
                <TextField
                    defaultValue={searchText}
                    floatingLabelText='Search'
                    onChange={handleSearch}
                />
                <div>
                    {renderPagination}
                </div>
            </div>
            <div className='table-body'>
                <div className='item'>
                    <Table selectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    Company name
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS} />
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    Real Company name
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    {null}
                                </TableHeaderColumn>
                            </TableRow>
                        </TableHeader>

                        <TableBody displayRowCheckbox={false}>
                            {
                                rows.map(company => (
                                    <CompaniesRealNamesRow 
                                        key={company._id} 
                                        company={company}
                                    />
                                ))
                            }
                        </TableBody>
                    </Table>
                </div>
            </div>
        </div>
    );
}

export default connect(
    (state) => {
        return {
            companies: state.companies.items,
        };
    },
    dispatch => bindActionCreators({
        // searchCargoRealNames,
    },
    dispatch),
)(CompaniesRealNamesTable);



// WEBPACK FOOTER //
// ./app/components/Companies/CompanyRealName/CompaniesRealNamesTable.jsx